<template>
    <section class="g-container || o-band">
        <div class="o-container">

            <app-intro class="u-d-flex align-items-center justify-content-between">
                <h3 class="u-mb-0">Facturen</h3>

                <router-link to="/admin/invoices" class="c-link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.589" height="12.388" viewBox="0 0 18.589 12.388">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                            <path d="M17.589 6.223H4.714"/>
                            <path d="M7.439 10.989L1.001 6.195l6.438-4.8" stroke-linejoin="round"/>
                            <path d="M7.439 10.99L5.894 6.195l1.545-4.8" stroke-linejoin="round"/>
                        </g>
                    </svg>

                    Terug <span class="u-hidden-xsl-down">naar overzicht</span>
                </router-link>
            </app-intro>

            <transition-group class="" name="fade" tag="section" v-if="invoices.length > 0">
                <div class="table table--bordered" key="table">
                    <div class="table__thead">
                        <div class="table__tr" v-for="invoice in invoices" :key="'thead-' + invoice.FactuurID">
                            <div class="table__th">Factuur</div>
                            <div class="table__th">Datum</div>
                            <div class="table__th">Omschrijving</div>
                            <div class="table__th">Factuur bedrag</div>
                            <div class="table__th">Openstaand bedrag</div>
                            <div class="table__th"></div>
                        </div>
                    </div>
                    <div class="table__tbody">

                        <div class="table__tr" v-for="invoice in invoices" :key="'tbody-' + invoice.FactuurID">
                            <div class="table__td">{{ invoice.FactuurID }}</div>
                            <div class="table__td">{{ invoice.Datum }}</div>
                            <div class="table__td">{{ invoice.Omschrijving }}</div>
                            <div class="table__td || u-text-right">&euro; {{ invoice.FactuurBedrag }}</div>
                            <div class="table__td || u-text-right">&euro; {{ invoice.OpenstaandBedrag }}</div>
                            <div class="table__td || u-text-right">
                                <a href="#0" class="c-link || u-font-weight-normal" :data-id="invoice.FactuurID" @click.prevent="getPdf">
                                    PDF
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 10.792 10.791">
                                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                                            <path d="M1 5.396h8.791"/>
                                            <path d="M5.396 1v8.791"/>
                                        </g>
                                    </svg>
                                </a>
                            </div>
                        </div>


                    </div>
                </div>
            </transition-group>

            <div v-else>
                <p>Geen facturen gevonden</p>
            </div>

            <loading v-bind:nodes="invoices">Bezig met laden van de facturen...</loading>

        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import AppIntro from '../../components/app/AppIntro.vue';
    import Loading from '../../components/Loading.vue';

    export default {
        components: { AppIntro, Loading },
        data () {
            return {

            };
        },
        computed: {
            ...mapState({
                invoices: (state) => state.invoice.list,
            }),
        },
        created () {
            this.$store.dispatch('invoice/list', this.$route.params.id);
        },
        methods: {
            async getPdf (e) {
                const id = e.target.dataset.id;
                const data = await this.$store.dispatch('invoice/pdf', id);
                this.downloadPdf(data, id);
            },
            downloadPdf (response, filename) {
                // It is necessary to create a new blob object with mime-type explicitly set otherwise only Chrome works like it should
                const newBlob = new Blob([response], { type: 'application/pdf' });

                // IE doesn't allow using a blob object directly as link href instead it is necessary to use msSaveOrOpenBlob
                if (window.navigator && window.navigator.msSaveOrOpenBlob)
                {
                    window.navigator.msSaveOrOpenBlob(newBlob);
                    return;
                }

                // For other browsers:
                // Create a link pointing to the ObjectURL containing the blob.
                const data = window.URL.createObjectURL(newBlob);
                const link = document.createElement('a');
                link.href = data;
                link.download = `${filename}.pdf`;
                link.click();

                // For Firefox it is necessary to delay revoking the ObjectURL
                setTimeout(() => {
                    window.URL.revokeObjectURL(data);
                }, 100);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .table {
        @include media-breakpoint-down(xsl) {
            grid-template-columns: rem(150) 1fr;
        }

        @include media-breakpoint-only(sm) {
            grid-template-columns: rem(200) 1fr;
        }

        &__tr {
            @include media-breakpoint-up(md) {
                grid-template-columns: 0.67fr 0.75fr 1.25fr 1fr 1.25fr rem(125);
            }
        }
    }
</style>
